document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('button');
    if (button && button.querySelector('.loading-spinner')) {
      var spinner = button.querySelector('.loading-spinner');
      if (spinner.classList.contains('inactive')) {
        spinner.classList.remove('inactive');
        setTimeout(function () {
          spinner.classList.add('inactive');
        }, 2000);
      }
    }

    if (
      event.target.matches(
        '.cart-item-quantity__button, .cart-item-quantity__button *'
      )
    ) {
      handleCartQuantityChange(event.target.closest('.cart-item'));
      handleCheckoutButtonSpinner();
    }

    if (event.target.closest('.cart-item__remove-button')) {
      handleCheckoutButtonSpinner();
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('.cart-item-quantity__input')) {
      handleCartQuantityChange(event.target.closest('.cart-item'));
      handleCheckoutButtonSpinner();
    }
  });

  var variantPickerInputs = document.querySelectorAll(
    '.product-variant-picker input[type="radio"]'
  );
  variantPickerInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      var spinner = document.querySelector('.loading-spinner');
      if (spinner && spinner.classList.contains('inactive')) {
        spinner.classList.remove('inactive');
        setTimeout(function () {
          spinner.classList.add('inactive');
        }, 2000);
      }
    });
  });

  function handleCartQuantityChange(cartItem) {
    if (!cartItem) return;
    var spinner = cartItem.querySelector('.cart-item__totals-loading-spinner');
    if (spinner && spinner.classList.contains('inactive')) {
      spinner.classList.remove('inactive');
      setTimeout(function () {
        spinner.classList.add('inactive');
      }, 2000);
    }
  }

  function handleCheckoutButtonSpinner() {
    var checkoutSpinner = document.querySelector('#checkout .loading-spinner');
    if (checkoutSpinner && checkoutSpinner.classList.contains('inactive')) {
      checkoutSpinner.classList.remove('inactive');
      setTimeout(function () {
        checkoutSpinner.classList.add('inactive');
      }, 2000);
    }
  }
});

if (typeof window.subscriptionPlusApp === 'undefined') {
  window.subscriptionPlusApp = {};
}
window.subscriptionPlusApp.proxy_url = 'apps/subscription-plus';
window.subscriptionPlusApp.api_url =
  '/' + window.subscriptionPlusApp.proxy_url + '/api';
window.subscriptionPlusApp.customerID = 7571205947722;
window.subscriptionPlusApp.products = {};
window.subscriptionPlusApp.money_format = '£{{amount}}';
window.subscriptionPlusApp.currency = 'GBP';

// FundraiseUp.on('donationComplete', function (details) {
//   console.log('Donation Complete');
//   console.log(details);
// });

// FundraiseUp.on('checkoutOpen', function (details) {
//   console.log('Checkout Opened');
//   console.log(details);
// });

// FundraiseUp.on('checkoutClose', function (details) {
//   console.log('Checkout Closed');
//   console.log(details);
// });
